import React from "react";
import { Settings } from "lucide-react";

export function getCenterActionContent({
    activeMenu,
    currentTheme,
    attendanceTargetGroup,
    counselingTargetGroup,
    studentListType,
    setAttendanceTargetGroup,
    setCounselingTargetGroup,
    setStudentListType
}) {
    const isStudentOrTeacherMenu = ["students", "teachers"].includes(activeMenu);
    const isAttendanceMenu = activeMenu === "attendance";
    const isCounselingMenu = activeMenu === "counseling";

    if (!(isStudentOrTeacherMenu || isAttendanceMenu || isCounselingMenu)) {
        return null;
    }

    return (
        <div className="flex items-center gap-2 md:hidden">
            <div className={`flex p-1 rounded-xl items-center flex-shrink-0 ${currentTheme.lightBg}`}>
                <button
                    onClick={() => {
                        if (isAttendanceMenu) setAttendanceTargetGroup("students");
                        else if (isCounselingMenu) setCounselingTargetGroup("students");
                        else setStudentListType("student");
                    }}
                    className={`px-4 py-1.5 text-xs font-bold rounded-lg transition-all duration-200 ${(isAttendanceMenu ? attendanceTargetGroup === "students" : (isCounselingMenu ? counselingTargetGroup === "students" : studentListType === "student")) ? `bg-white shadow-sm ${currentTheme.text}` : "text-gray-400"}`}
                >
                    학생
                </button>
                <button
                    onClick={() => {
                        if (isAttendanceMenu) setAttendanceTargetGroup("teachers");
                        else if (isCounselingMenu) setCounselingTargetGroup("teachers");
                        else setStudentListType("teacher");
                    }}
                    className={`px-4 py-1.5 text-xs font-bold rounded-lg transition-all duration-200 ${(isAttendanceMenu ? attendanceTargetGroup === "teachers" : (isCounselingMenu ? counselingTargetGroup === "teachers" : studentListType === "teacher")) ? `bg-white shadow-sm ${currentTheme.text}` : "text-gray-400"}`}
                >
                    교사
                </button>
            </div>
        </div>
    );
}

export function getHeaderActionContent({
    activeMenu,
    currentTheme,
    setIsDashboardSettingsOpen,
    setIsStatsSettingsOpen
}) {
    const isStudentOrTeacherMenu = ["students", "teachers"].includes(activeMenu);

    if (activeMenu === "dashboard") {
        return (
            <div className="flex items-center gap-1">
                <button
                    onClick={() => setIsDashboardSettingsOpen(true)}
                    className={`hidden md:block p-2 rounded-full text-gray-400 hover:${currentTheme.text} hover:${currentTheme.hoverBg} transition-all relative`}
                    title="대시보드 설정"
                >
                    <Settings size={18} />
                </button>
            </div>
        );
    }

    if (isStudentOrTeacherMenu || activeMenu === "counseling") {
        return null;
    }

    if (activeMenu === "statistics") {
        return (
            <button
                onClick={() => setIsStatsSettingsOpen((prev) => !prev)}
                className={`p-2 rounded-full text-gray-400 hover:${currentTheme.text} hover:${currentTheme.hoverBg} transition-all relative ml-2`}
                title="통계 보드 설정"
            >
                <Settings size={18} />
            </button>
        );
    }

    return null;
}
